'use client';

// Third Party Plugins
import React from 'react';
// Types
import { NewsListProps } from './types';
// Custom Components
import PostCard from '@/components/cards/PostCard';
import CardGridContainer from '@/components/cards/CardGridContainer';

const NewsList: React.FC<NewsListProps> = ({ newsPosts }) => {
  return (
    <CardGridContainer>
      {newsPosts.map((post) => (
        <PostCard
          key={post._id}
          _id={post._id}
          image={post.newsImg?.asset?.url}
          altText={post.newsImg?.alt}
          tagText={post.newsTag}
          type={post._type}
          to={`/news/${post.slug.current}`}
          title={post.newsPostTitle}
          description={post.newsContentExcerpt}
          date={post.publishDate}
        />
      ))}
    </CardGridContainer>
  );
};

export default NewsList;
